<template>
    <div id="menbership">
        <el-container>
            <el-header height="55px">
                <el-container class="page_header">
                    <el-aside width="100px"><img class="title_icon" src="./img/img_icon_12.png" alt="">升级会员</el-aside>
                    <el-main style="color:#07c160;text-align:right;padding-right:20px;"><img class="title_icon" src="./img/img_icon_88.png" alt="">年费会员性价比更高！鉴于成本不断上涨，我们随时调整会员价格，请了解！</el-main>
                    <el-aside width="22vw" class="user_info">
                        <img class="title_icon avatar" :src="userInfo.avatarurl || df_avatar" >
                        <div class="user_name">{{ userInfo.nickname ? userInfo.nickname : "微信用户" }}</div>
                        <div :class="['vip_icon',userInfo.is_vip?'is_vip':'no_vip']"></div>
                        <div class="user_tag">
                            <template v-if="userInfo.utype==2">学生会员</template>
                            <template v-if="userInfo.utype==3">教师会员</template>
                            <template v-if="userInfo.utype==1&&userInfo.company_id>0">企业会员</template>
                            <template v-if="userInfo.utype==1&&userInfo.company_id==0">个人会员</template>
                        </div>
                    </el-aside>
                </el-container>
            </el-header>
            <el-main>
                <el-container style="padding: 20px 0">
                    <el-main class="page_main">
                        <el-container>
                            <el-header>
                                <div class="main_header">
                                    <div @click="changeTab(tab)" :class="['header_tab',{'active':tab.pay_type==selectTab}]" v-for="tab in vipList" :key="tab.pay_type">
                                        {{tab.name}}<span class="tab_tag"></span>
                                    </div>
                                </div>
                            </el-header>
                            <el-main class="content_main">
                                <el-scrollbar class="write_scrollbar">
                                    <div class="vip_list">
                                        <div :class="['vip_item',{'active':selectedVip.vip_type==vip.vip_type}]" v-for="(vip,i) in vipData.goods" :key="vip.vip_type"  @click="chooseSetMeal(vip)">
                                            <div class="item_top">
                                                <img v-if="vip.favorite" class="favorite_icon" src="./img/img_icon_89.png" alt="">
                                                <div class="vip_name">{{ vip.name }}<span class="name_desc" v-if="selectTab=='monthon'&&vip.vip_type>0"> - 连续包月</span></div>
                                                <div class="day_count"><span :class="['vip_icon','is_vip_'+vip.vip_type]"></span><span style="font-size: 14px;">{{ vip.tip }}</span></div>
                                                <div class="vip_price">￥<span class="price_count"> {{ vip.show_money ||vip.pay_money}} </span>元/<template v-if="selectTab=='monthon'&&vip.vip_type>0">首</template>{{ selectUnit }}</div>
                                                <div :class="['vip_desc',{'red':i!=0}]"><span v-if="vip.raw_money" style="text-decoration: line-through;">￥{{ vip.raw_money}}元/{{ selectUnit }}</span><span v-if="vip.raw_money">，</span>{{ vip.tip2 }}</div>
                                            </div>
                                            <div class="item_content">
                                                <div class="vip_tq" v-for="p in vip.privilege">{{p}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="buy_num" v-show="!isShowPayCode&&userInfo.utype==1&&userInfo.company_id>0">
                                        <div class="num_label">请输入购买人数:</div>
                                        <el-input-number style="margin:0 12px;" v-model="buy_num" :min="3"></el-input-number>
                                        <el-button type="info" style="width:100px" @click="saveBuyNum">确定</el-button>
                                    </div>
                                    <div class="pay_wrap" v-show="(isShowPayCode&&userInfo.utype==1&&userInfo.company_id>0)||userInfo.utype>=1&&userInfo.company_id==0">
                                        <div class="pay_code">
                                            <img class="timeout" v-if="left_time==0||selectedVip.show_money==0" src="./img/img_icon_90.jpg" alt="" srcset="">
                                            <canvas class="timeout" v-else id="canvas"></canvas>
                                            <div class="jiao"></div>
                                        </div>
                                        <div class="pay_info">
                                            <div class="line_one">应付金额：<span class="pay_money">￥<span class="money_count" v-if="userInfo.company_id>0">{{ selectedVip.show_money*buy_num }}</span><span class="money_count" v-if="userInfo.company_id==0">{{ selectedVip.show_money }}</span>元/{{ selectUnit }}</span><span class="buy_user" v-if="userInfo.company_id>0">{{ buy_num }}人</span><span class="coupon" v-if="coupon_id">优惠券：{{coupon_money}}元</span>将在 <span class="left_time">{{ left_time_text }}</span> 秒后过期，请尽快完成支付</div>
                                            <div class="line_two">请使用<template v-if="selectTab!='monthon'">
                                                <span class="pay_type wx_pay"><img class="pay_icon" src="./img/img_icon_91.png" alt="">微信支付</span>或
                                            </template><span class="pay_type ali_pay"><img class="pay_icon" src="./img/img_icon_92.png" alt="">支付宝</span>扫一扫二维码进行支付</div>
                                            <div class="agreement"><el-checkbox v-model="agreement"></el-checkbox> 开通会员代表您接受 <a target="_blank" href="http://help.xiutanshu.com/help/agree.html">《订阅会员协议》</a>，开发票请联系在线客服</div>
                                        </div>
                                    </div>
                                </el-scrollbar>
                            </el-main>
                        </el-container>
                    </el-main>
                    <el-aside width="22vw">
                        <el-container class="qa_wrap">
                            <el-header class="question_header">常见问题</el-header>
                            <el-main style="padding-bottom:12px;">
                                <el-scrollbar class="write_scrollbar">
                                    <div class="quest_item">
                                        <div class="quest_line">开通会员后，字数不够用怎么办？</div>
                                        <div class="answer_line">一般情况下钻石会员每天8万字是足够写作使用的，如果您还不够用，请 <el-button style="padding:4px 5px;" @click="showCharge" size="mini" type="primary">点此购买字数包</el-button></div>
                                    </div>
                                    <div class="quest_item" v-for="q in questions">
                                        <div class="quest_line">{{ q.Q }}</div>
                                        <div class="answer_line">{{ q.A }}</div>
                                    </div>
                                </el-scrollbar>
                            </el-main>
                        </el-container>
                    </el-aside>
                </el-container>
            </el-main>
        </el-container>
        <wordCharge ref="wordCharge"></wordCharge>
    </div>
</template>
<script type="text/ecmascript-6">
    import QRCode from 'qrcode'
    import wordCharge from 'COMPONENTS/WordCharge.vue'
    export default {
        components:{ wordCharge},
        data() {
            return {
                df_avatar:require("./img/img_icon_17.png"),
                selectTab:"month",
                selectUnit:"月",
                vipList:[
                    {
                        pay_type:'monthon',
                        name:"连续包月",
                        desc:"仅支持支付宝",
                        unit:"月"
                    },
                    {
                        pay_type:'month',
                        name:"单月购买",
                        desc:"支持微信支付",
                        unit:"月"
                    },
                    {
                        pay_type:'year',
                        name:"包年会员",
                        desc:"节约50%费用",
                        unit:"年"
                    },
                    {
                        pay_type:'life_year',
                        name:"终身会员",
                        desc:"",
                        unit:"终身"
                    },

                ],
                selectedVip:{},
                vipDetails:[
                ],
                coupon_money:0,
                coupon_id:0,
                left_time:600,
                left_time_text:"10:00",
                agreement:true,
                questions:[
                    {
                        Q:"购买后支持退款吗？",
                        A:"不支持。懒人办公提供的付费服务属虚拟产品，请您在购买前确认服务内容、功能和条款，非故障情况，一经生效，不支持退款，请您谅解。"
                    },
                    {
                        Q:"个人会员和企业会员有什么区别？",
                        A:"人会员仅可查看自己的文档，企业会员管理员可以查看和管理所有成员的文档，成员账号权益和个人会员无差别！一旦企业成员被管理员踢出，会员权益会随之取消！"
                    },
                    {
                        Q:"开通了会员，为什么无法使用？",
                        A:"首先由于充值会存在延迟状况，付款后如果显示免费版，可先刷新页面或重新登录。如果还是无法显示。可以通过将第三方支付截图提交给在线客服获取查询原因并给与解决支持。"
                    },
                    {
                        Q:"懒人办公是如何计算字数的？",
                        A:"字数是按照机器人输出和输入计算的，以及您滑动命令填喂机器人字数，以及点击编辑器底部的一键整篇分析、相关问题汇总（这个是计算量消耗最大）等都会被计算字数。如果您是导入文档或者复制粘贴到编辑器内是不算字数的！"
                    },
                    {
                        Q:"开通会员后，是否可以升级其他会员套餐？",
                        A:"可以。优先使用最高级别会员权益。例如：目前为黄金年费会员，已使用半年，再次购买钻石年费会员。系统会优先使用钻石会员，到期后自动转为黄金会员并衔接时长，可继续使用半年。"
                    },
                    {
                        Q:"可以开发票报销吗？",
                        A:"可以，任何VIP和套餐的订阅，都可开增值税普通发票和增值税专用发票，发票内容默认为技术服务费，开票金额就是充值金额。请联系在线客服为您服务。"
                    },
                    {
                        Q:"个人和企业会员权益可以共享吗？",
                        A:"不可以。个人会员和企业会员除了一键登录互通，其他相互不受影响，文档也不可以共享，当然会员权益也不可以共享！"
                    },
                    {
                        Q:"懒人办公怎么突然“淘气”打不开了？",
                        A:"可能是由于懒人办公正在变得“更聪明”（升级更新），请耐心等待几分钟后重试即可，如果长时间还是无法登录，请联系在线客服；另外，在系统进行了较大升级的情况下，有历史缓存将导致报错，请清除缓存可帮助消除报错和正常使用。"
                    },
                ],
                vipData:{},
                buy_num:1,
                isShowPayCode:false,
            }
        },
        created() {
            this.fetchGoodsList();
        },
        computed:{
            userInfo(){
                return this.$store.state.userInfo;
            }
        },
        methods: {
            changeTab(tab){
                // if(tab.pay_type !== "monthon"){
                //     this.$toast("此功能暂未上线！");
                //     return
                // }
                this.selectTab = tab.pay_type;
                this.selectUnit = tab.unit
                this.fetchGoodsList()
            },
            fetchGoodsList(){
                this.$http.get('/front/aixz/membership/',{params:{pay_type:this.selectTab}}).then((res) => {
                    if(res.status == 200){
                        this.vipData = res.data.vip_info;
                        this.chooseSetMeal(this.vipData.goods[3])
                    }
                })
            },
            chooseSetMeal(vip){
                this.selectedVip = vip

                this.left_time_text = "10:00"
                this.left_time = 600
                if(this.timer)
                    clearInterval(this.timer);
                if(this.payTimer)
                    clearTimeout(this.payTimer);
                
                if(vip.pay_money==0){
                    return
                }
                //如果支付二维码可以放在payTypes列表中，就不需要请求接口了
                let data = { "appid":APP_ID, "pro_id": vip.id,"pay_type":this.selectTab, "vip_type":vip.vip_type, "pay_from": "h5pay", "pay_flat": 1, coupon_id: this.coupon_id }
                data.buy_num = this.buy_num
                this.$http.post('/front/aixz/chongzhi/?scanpay=1', data).then((res) => {
                    if(res.status == 200){
                        this.code_url = res.data.pay_url;
                        this.uniq_key = res.data.uniq_key;
                        var canvas = document.getElementById('canvas')
                        QRCode.toCanvas(canvas, this.code_url, function (error) {
                            if (error) console.error(error)
                        })
                        this.setPayTime()
                    }
                })
            },
            setPayTime() {
                this.timer = setInterval(()=>{
                    this.left_time--;
                    let m = parseInt(this.left_time/60);
                    let s = this.left_time%60;
                    if(m < 10) m = "0"+m
                    if(s < 10) s = "0"+s
                    this.left_time_text = m +":"+s
                    if(this.left_time == 0){
                        // this.left_time = 600
                        clearTimeout(this.timer)
                    } 
                },1000)
            },
            saveBuyNum(){
                // 企业会员确定购买人数
                this.isShowPayCode = true
                this.chooseSetMeal(this.selectedVip)
            },
            showCharge(val){
                this.$refs.wordCharge.show()
            },
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    #menbership{
        height: 100%;
        padding: 0 20px;
        .el-container{
            height: 100%;
        }
        .page_header{
            border-bottom: 1px solid #e5e5e5;
            line-height: 54px;
            .title_icon{
                width: 16px;
                vertical-align: middle;
                margin: -3px 8px 0 0;
            }
            .user_info{
                display: flex;
                align-items: center;
                justify-content: flex-end;
                .avatar{
                    border-radius: 50%;
                }
                .user_name{
                    font-size: 12px;
                }
                .vip_icon{
                    display: inline-block;
                    width: 14px;
                    height: 14px;
                    vertical-align: middle;
                    background-size: 100% 100%;
                    margin: -2px 8px 0;
                    &.is_vip{
                        background-image: url("./img/img_icon_15.png");
                    }
                    &.no_vip{
                        background-image: url("./img/img_icon_16.png");
                    }
                }
                .user_tag{
                    width: 35px;
                    height: 16px;
                    border-radius: 3px;
                    background-color: #424242;
                    color: #fff;
                    font-size: 12px;
                    text-align: center;
                    line-height: 16px;
                }
            }
        }
        .page_main{
            margin-right: 20px;
            overflow: hidden;
            .main_header{
                display: flex;
                margin-bottom: 20px;
                .header_tab{
                    flex-grow: 1;
                    width: 0;
                    border-radius: 2px;
                    background-color: #e5e5e5;
                    margin-right: 12px;
                    text-align: center;
                    height: 48px;
                    line-height: 48px;
                    cursor: pointer;
                    user-select: none;
                    &:first-child .tab_tag{
                        background-image: url("./img/img_icon_106.gif");
                        // background-image: url("./img/img_icon_107.gif");
                    }
                    &:nth-of-type(2) .tab_tag{
                        background-image: url("./img/img_icon_107.gif");
                        // background-image: url("./img/img_icon_93.png");
                    }
                    &:nth-of-type(3) .tab_tag{
                        background-image: url("./img/img_icon_93.png");
                    }
                    &:last-child{
                        margin-right: 0;
                        .tab_tag{
                            background-image: url("./img/img_icon_108.gif");
                        }
                    }
                    &.active{
                        flex-grow: 1.8;
                        background-color: #07c160;
                        color: #fff;
                        position: relative;
                        &::after{
                            content: "";
                            display: block;
                            width: 28px;
                            height: 28px;
                            position: absolute;
                            background-size: 100% 100%;
                            background-image: url("./img/img_icon_94.png");
                            right: 0;
                            bottom: 0;
                        }
                    }
                    .tab_tag{
                        display: inline-block;
                        width: 80px;
                        height: 18px;
                        vertical-align: middle;
                        margin: -2px 0 0 6px;
                    }
                }
            }
            .content_main{
                border: 1px solid #eee;
                background-color: #fff;
                .vip_list{
                    display: flex;
                    border-bottom: 1px solid #eee;
                    .vip_item{
                        width: 0;
                        flex-grow: 1;
                        cursor: pointer;
                        &.active{
                            background-color: #eee;
                            .item_top{
                                border-color: #ddd;
                            }
                        }
                        &:not(:last-child){
                            border-right: 1px solid #eee;
                        }
                        .item_top{
                            padding: 20px 10px 13px 24px;
                            position: relative;
                            border-bottom: 1px solid #eee;
                            min-height: 173px;
                            .favorite_icon{
                                position: absolute;
                                top: 0;
                                right: 0;
                                display: block;
                                top: 0;
                                right: 0;
                            }
                            .vip_name{
                                line-height: 28px;
                                font-size: 20px;
                                font-weight: bold;
                                .name_desc{
                                    font-size: 14px;
                                }
                            }
                            .day_count{
                                font-size: 13px;
                                color: #999;
                                line-height: 25px;
                                display:flex;
                                align-items:center;
                                .vip_icon{
                                    display: block;
                                    flex-shrink: 0;
                                    width: 14px;
                                    height: 17px;
                                    background-size: 100% 100%;
                                    margin: 0 4px 0 0;
                                    &.is_vip_0{
                                        background-image: url("./img/vip_type_0.png");
                                    }
                                    &.is_vip_1{
                                        background-image: url("./img/vip_type_1.png");
                                    }
                                    &.is_vip_2{
                                        background-image: url("./img/vip_type_2.png");
                                    }
                                    &.is_vip_3{
                                        background-image: url("./img/vip_type_3.png");
                                    }
                                }
                            }
                            .vip_price{
                                margin-top: 12px;
                                font-size: 19px;
                                line-height: 39px;
                                color: #07c160;
                                font-weight:bold;
                                .price_count{
                                    font-size: 34px;
                                    font-weight: bold;
                                }
                            }
                            .vip_desc{
                                font-size: 14px;
                                color: #ccc;
                                line-height: 22px;
                                margin-top: 6px;
                                &.red{
                                    color: #c00;
                                }
                            }
                        }
                        .item_content{
                            padding: 13px 20px;
                            .vip_tq{
                                line-height: 24px;
                                margin-bottom: 6px;
                                color: #a0a0a0;
                                padding-left: 16px;
                                position: relative;
                                &::before{
                                    content: "";
                                    display: block;
                                    width: 4px;
                                    height: 4px;
                                    background-color: #a0a0a0;
                                    position: absolute;
                                    left: 0;
                                    top: 50%;
                                    margin-top: -2px;
                                }
                            }
                        }
                    }
                }
                .buy_num{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 192px;
                    background-color: #eee;
                    margin-top: 20px;
                }
                .pay_wrap{
                    display: flex;
                    padding: 24px 28px;
                    .pay_code{
                        width: 160px;
                        height: 160px;
                        border: 1px solid #e1e1e1;
                        padding: 10px;
                        margin-right: 30px;
                        position: relative;
                        .timeout{
                            display: block;
                            width: 100%!important;
                            height: 100%!important;
                        }
                        &:before,&:after,.jiao:before,.jiao:after{
                            content: "";
                            display: block;
                            position: absolute;
                            width: 24px;
                            height: 24px;
                            border: 3px solid #07c160;
                        }
                        &:before{
                            top: -3px;
                            left: -3px;
                            border-right: none;
                            border-bottom: none;
                        }
                        &:after{
                            top: -3px;
                            right: -3px;
                            border-left: none;
                            border-bottom: none;
                        }
                        .jiao:before{
                            bottom: -3px;
                            left: -3px;
                            border-right: none;
                            border-top: none;
                        }
                        .jiao:after{
                            bottom: -3px;
                            right: -3px;
                            border-left: none;
                            border-top: none;
                        }
                    }
                    .pay_info{
                        flex-grow: 1;
                        .line_one{
                            margin-bottom: 35px;
                            line-height: 30px;
                            .pay_money{
                                color: #07c160;
                                padding-right: 10px;
                                .money_count{
                                    font-size: 34px;
                                    font-weight: bold;
                                }
                            }
                            .buy_user{
                                padding-right: 10px;
                                color: #07c160;
                                font-size: 14px;
                            }
                            .coupon{
                                padding-right: 30px;
                            }
                            .left_time{
                                color: #07c160;
                            }
                        }
                        .line_two{
                            line-height: 30px;
                            font-weight: bold;
                            margin-bottom: 44px;
                            .pay_type{
                                padding: 0 20px;
                                &.wx_pay{
                                    color: #09bb07;
                                }
                                &.ali_pay{
                                    color: #009fe8;
                                    padding-left: 23px;
                                    position: relative;
                                    &::after{
                                        content: "支付宝付款立减 3 元";
                                        display: block;
                                        font-weight: 400;
                                        width: 122px;
                                        height: 52px;
                                        position: absolute;
                                        left: 11px;
                                        bottom: -2px;
                                        color: #fff;
                                        font-size: 12px;
                                        line-height: 22px;
                                        text-align: center;
                                        // background-image: url("./img/img_icon_99.png");
                                    }
                                }
                                .pay_icon{
                                    vertical-align: middle;
                                    margin: -2px 8px 0 0;
                                    width: 16px;
                                }
                            }
                        }
                        .agreement{
                            font-size: 12px;
                            color: #ccc;
                            line-height: 16px;
                            a{
                                color: #07c160;
                            }
                        }
                    }
                }
            }
        }
        .qa_wrap{
            background-color: #fff;
            padding: 0 16px;
            .question_header{
                font-weight: bold;
                line-height: 44px;
                border-bottom: 1px solid #eee;
            }
            .quest_item{
                border-bottom: 1px solid #eee;
                padding: 16px 0;
                line-height: 24px;
                .quest_line{
                    margin-bottom: 5px;
                }
                .answer_line{
                    color: #999;
                }
            }
        }
    }
</style>